import { css, cx } from "@emotion/css";
import { Colors, FontWeight } from "@snapchat/snap-design-system";

export const linkButtonBaseOverride = css`
    &.sds-base-button.ant-btn {
        text-decoration: none;
    }
`;

export const linkButtonElevated = css`
    &.sds-base-button {
        font-weight: ${FontWeight.MEDIUM};
        color: ${Colors.Black.V100};
        box-shadow: 0 2px 4px 0 #00000024;

        &:hover,
        &:active,
        &:focus {
            color: ${Colors.Black.V50};
        }
    }
`;

export const linkButtonBlack = css`
    &.sds-base-button.ant-btn {
        color: ${Colors.WHITE};
        background-color: ${Colors.Black.V200};

        &:hover,
        &:active,
        &:focus {
            background-color: ${Colors.Black.V100};
        }
    }
`;

export const linkButtonBlackSmallClassName = cx(
    "sds-base-button",
    "ant-btn",
    "primary",
    "small",
    linkButtonBlack,
    linkButtonBaseOverride,
);
export const linkButtonPrimaryClassName = cx("sds-base-button", "ant-btn", "primary", linkButtonBaseOverride);
export const linkButtonDefaultClassName = cx("sds-base-button", "ant-btn", "default", linkButtonBaseOverride);
export const linkButtonSmallClassName = cx("sds-base-button", "ant-btn", "default", "small", linkButtonBaseOverride);
export const linkButtonElevatedClassName = cx("sds-base-button", "ant-btn", linkButtonBaseOverride, linkButtonElevated);
